export const BRAND = {
  name: "Alijay Empire",
  shortName: "ALIJAY",
  tagline: "Abnormal Load Management",
  productName: "Transport Command Center",
  footerLine: "Heavy Load Logistics · Route Optimization · Compliance Ready",
  initials: "AE",
  developer: "Icon Industries"
};

export const BRAND_COLORS = {
  primary: "#004a76",
  primaryDark: "#003a5d",
  accent: "#ed1c24",
  accentDark: "#c1131a",
  surface: "#f4f7fb",
  text: "#0f172a"
};
